import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putControl } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.PUT,
  api: putControl,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controls/PutAction.js